import { Components, Theme } from '@mui/material/styles'

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-selected': {
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.states.secondary.outlinedBorder}`,
      },
    }),
    sizeSmall: {
      padding: '3px 6px',
    },
    sizeMedium: {
      padding: '7px 14px',
    },
    sizeLarge: {
      padding: '11px 22px',
    },
  },
}
